<template>
  <base-entity-card
    :id="id"
    titleName="портфолио"
    :saveFunc="save"
    :loading="loading"
    @closed="restoreEntity"
    :oneColumn="false"
  >
    <v-form ref="form" v-model="isValid">
      <v-autocomplete
        label="Сайт"
        v-model="entity.site"
        :items="sitesSelectData"
        clearable
        filled
      ></v-autocomplete>
      <v-text-field
        label="Название *"
        v-model="entity.name"
        :rules="[v => !!v || 'Введите название портфолио.']"
        filled
      ></v-text-field>
      <v-text-field
        label="Полное название *"
        v-model="entity.header"
        :rules="[v => !!v || 'Введите полное название платформы.']"
        filled
      ></v-text-field>
      <v-text-field
        label="Тэг *"
        v-model="entity.tag"
        :rules="[v => !!v || 'Введите тэг.']"
        filled
        append-icon="mdi-autorenew"
        @click:append="generateTag()"
      ></v-text-field>
      <v-switch 
        v-model="entity.objectInfo.isActive" 
        :label="`Карточка объекта: ${entity.objectInfo.isActive ? 'включена' : 'отключена'}`"
      >
      </v-switch>
      <template v-if="entity.objectInfo.isActive">
        <v-text-field
          label="Название объекта *"
          v-model="entity.objectInfo.name"
          filled
          :rules="[v => !!v || 'Введите название.']"
        ></v-text-field>
        <v-text-field
          label="Адрес (или название ЖК)"
          v-model="entity.objectInfo.addressName"
          filled
        ></v-text-field>
        <v-text-field
          label="Площадь объекта (м2)"
          v-model="entity.objectInfo.square"
          filled
        ></v-text-field>
        <v-text-field
          label="Стоимость работ (руб)"
          v-model="entity.objectInfo.servicesPrice"
          filled
          :rules="[v => !v || isNumber(v) || 'Введите число']"
        ></v-text-field>
        <v-text-field
          label="Стоимость черновых материалов (руб)"
          v-model="entity.objectInfo.blackMaterialPrice"
          filled
          :rules="[v => !v || isNumber(v) || 'Введите число']"
        ></v-text-field>
        <v-text-field
          label="Срок выполнения (кал. дн.)"
          v-model="entity.objectInfo.periodOfProductionDays"
          filled
          :rules="[v => !v || isNumber(v) || 'Введите число']"
        ></v-text-field>
       
      </template>
      <v-data-table
        class="elevation-1"
        :headers="tableHeaders"
        :items="items"
      >
        <template v-slot:top>
          <div class="d-flex">
            <v-card-title>Фотографии</v-card-title>
            <v-spacer></v-spacer>
            <site-portfolio-photo-card
              @input="savePhoto($event)"
            ></site-portfolio-photo-card>
          </div>
        </template>
        <template v-slot:[`item.updown`]="{ item }">
          <div style="display: inline-block; width: 10px;">
            <v-icon small @click="upPhoto(item.index)">mdi-menu-up</v-icon>
            <v-icon small @click="downPhoto(item.index)">mdi-menu-down</v-icon>
          </div>
        </template>
        <template v-slot:[`item.photo`]="{ item }">
          <img style="max-width:200px; max-height:200px;" :src="item.file[0].smallImagelUrl">
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <site-portfolio-photo-card
            :value="item"
            @input="savePhoto($event)"
            :key="String(item._id)"
          ></site-portfolio-photo-card>
          <delete-button
            :id="item._id"
            objName="фото"
            :deleteFunc="deletePhoto"
          ></delete-button>
        </template>
      </v-data-table>
    </v-form>
  </base-entity-card>
</template>

<script>
import SiteEntityMixin from '../../../models/SiteEntityMixin';
import { transliterate as tr, slugify } from 'transliteration';
import { mapGetters } from 'vuex';
import SitePortfolioPhotoCard from './SitePortfolioPhotoCard';
const MongoID = require('mongoose').Types.ObjectId;

export default {
  name: 'site-portfolio-card',

  mixins: [SiteEntityMixin],

  components: {
    SitePortfolioPhotoCard
  },

  data() {
    return {
      tag: 'portfolio',
      tableHeaders: [
        {
          text: '',
          value: 'updown'
        },
        {
          text: 'Фото',
          value: 'photo'
        },
        {
          text: 'Описание',
          value: 'description'
        },
        {
          text: 'Действия',
          value: 'actions'
        }
      ]
    }
  },

  methods: {
    getDefaultEntity() {
      return {
        site: null,
        name: '',
        header: '',
        tag: '',
        objectInfo: {
          isActive: false,
          name: '', 
          addressName: '',
          square: '',
          servicesPrice: null, // Стоимость работ
          blackMaterialPrice: null, // Стоимость черновых материалов
          periodOfProductionDays: null, // Срок реализации (кал. дней)
        },
        photos: []
      }
    },
    generateTag() {
      this.entity.tag = slugify(this.entity.header);
    },
    savePhoto(newObj) {
      if (newObj._id) {
        let index = this.entity.photos.findIndex(x => x._id == newObj._id);
        this.entity.photos.splice(index, 1, newObj);
      } else {
        newObj._id = String(new MongoID());
        this.entity.photos.push(newObj);
      }
      this.$store.dispatch('showMessage', 'Фотография успешно сохранена.');
    },
    async deletePhoto(id) {
      let index = this.entity.photos.findIndex(x => x._id == id);
      this.entity.photos.splice(index, 1);
      return { message: 'Фото успешно удалено.' };
    },
    upPhoto(index) {
      if (index > 0) {
        let p1 = this.entity.photos[index];
        let p2 = this.entity.photos[index - 1];
        this.entity.photos.splice(index - 1, 2, p1, p2);
      }
    },
    downPhoto(index) {
      if (index < this.entity.photos.length - 1) {
        let p1 = this.entity.photos[index];
        let p2 = this.entity.photos[index + 1];
        this.entity.photos.splice(index, 2, p2, p1);
      }
    },
  },

  computed: {
    ...mapGetters('sites', ['testimonialsSelectData']),
    items() {
      return this.entity.photos.map((x, index) => ({ ...x, index }));
    }
  }
}
</script>